import { useMemo } from "react";
import { useTranslation, Trans } from "react-i18next";

// 👉 если Swiper уже используешь в проекте
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function Bubble({ variant = "q", children }) {
  const isQ = variant === "q";

  return (
    <div className="relative">
      {isQ ? (
        <div>
            <div className="bg-[#061A77] xl:hidden w-full h-[155px]"></div>
            <svg className="hidden xl:block" xmlns="http://www.w3.org/2000/svg" width="393" height="155" viewBox="0 0 393 155" fill="none">
                <path d="M0 4C0 1.79086 1.79086 0 4 0L389 0C391.209 0 393 1.79086 393 4V154.5L380.698 133.865C379.976 132.654 378.671 131.913 377.262 131.913H343.875H294.75H196.5H4C1.79086 131.913 0 130.122 0 127.913V4Z" fill="#061A77"/>
            </svg>
        </div>
      ) : (
        <div>
            <div className="bg-[#F1F7FE] xl:hidden w-full h-[195px]"></div>
            <svg className="hidden xl:block" xmlns="http://www.w3.org/2000/svg" width="393" height="195" viewBox="0 0 393 195" fill="none">
                <path d="M393 4C393 1.79086 391.209 0 389 0H4C1.79086 0 0 1.79086 0 4V195L12.3022 174.365C13.0237 173.154 14.3289 172.413 15.7379 172.413H49.125H98.25H196.5H389C391.209 172.413 393 170.622 393 168.413V4Z" fill="#F1F7FE"/>
            </svg>
        </div>
      )}

      <div className="absolute top-[35px] px-[35px]">
        <p className={`${isQ ? "text-white" : "text-[#000000B2]"} inter font-[500] text-[14px]`}>
          {children}
        </p>
      </div>
    </div>
  );
}

function QA() {
  const { t } = useTranslation();

  // ✅ массив Q/A (ключи переводов)
  const items = useMemo(
    () => [
      { q: "ambassador.13", a: "ambassador.15" },
      { q: "ambassador.14", a: "ambassador.16" },
      { q: "ambassador.17", a: "ambassador.20" },
      { q: "ambassador.18", a: "ambassador.21" },
      { q: "ambassador.19", a: "ambassador.22" },
    ],
    []
  );

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <div className="xl:grid grid-cols-3 gap-[20px] gap-y-[40px] hidden">
                <div>
                    <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.2]">
                        <Trans>{t("ambassador.11")}</Trans>
                    </p>
                    <p className="poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[20px] xl:max-w-[300px]">
                        {t("ambassador.12")}
                    </p>

                    <svg className="mt-[60px]" xmlns="http://www.w3.org/2000/svg" width="88" height="50" viewBox="0 0 88 50" fill="none">
                        <path
                        d="M42.0171 0C43.1377 0 43.5735 0.498031 43.5735 1.55635V5.78962C43.5112 6.59892 43.2622 7.40822 42.8264 8.15527L11.575 49.2429C11.0769 49.9899 10.0186 50.2389 9.20931 49.7409L0.618269 45.0718C-0.00427078 44.5738 -0.128771 43.9513 0.120245 42.893L12.073 1.4941C12.2598 0.684799 12.9446 0.124515 13.8161 0.124515H42.0171V0ZM86.3419 0C87.4625 0 87.8983 0.498031 87.8983 1.55635V5.78962C87.836 6.59892 87.587 7.40822 87.1512 8.15527L55.8998 49.2429C55.4017 49.9899 54.3434 50.2389 53.5341 49.7409L44.8186 45.0718C44.196 44.5738 44.0715 43.9513 44.3205 42.893L56.2733 1.4941C56.46 0.622545 57.2694 0.0622615 58.1409 0.124515H86.3419V0Z"
                        fill="#65CDBF"
                        />
                    </svg>
                </div>
                {items.map((it, idx) => (
                    <div key={idx} className="flex flex-col gap-[9px]">
                        <Bubble variant="q">{t(it.q)}</Bubble>
                        <Bubble variant="a">{t(it.a)}</Bubble>
                    </div>
                ))}
            </div>
            <div className="xl:hidden">
                <div className="flex justify-between items-center">
                    <p className="text-[32px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.2]">
                        <Trans>{t("ambassador.11")}</Trans>
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="55" height="32" viewBox="0 0 55 32" fill="none">
                        <path d="M26.2425 0C26.9424 0 27.2145 0.311054 27.2145 0.972042V3.616C27.1756 4.12146 27.0201 4.62692 26.7479 5.0935L7.22933 30.7554C6.91828 31.222 6.25729 31.3775 5.75183 31.0665L0.38615 28.1503C-0.00266738 27.8393 -0.080426 27.4505 0.0751008 26.7895L7.54039 0.933164C7.65703 0.427702 8.08473 0.0777681 8.62908 0.0777681H26.2425V0ZM53.9263 0C54.6261 0 54.8983 0.311054 54.8983 0.972042V3.616C54.8594 4.12146 54.7039 4.62692 54.4317 5.0935L34.9131 30.7554C34.6021 31.222 33.9411 31.3775 33.4356 31.0665L27.9922 28.1503C27.6033 27.8393 27.5256 27.4505 27.6811 26.7895L35.1464 0.933164C35.263 0.388821 35.7685 0.0388864 36.3128 0.0777681H53.9263V0Z" fill="#65CDBF"/>
                    </svg>
                </div>
                <p className="poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2] mt-[12px] xl:max-w-[300px]">
                    {t("ambassador.12")}
                </p>
                <Swiper 
                    modules={[Navigation, A11y]}
                    navigation={{
                        prevEl: ".news-prev",
                        nextEl: ".news-next",
                    }} 
                    className="mt-[50px]" 
                    spaceBetween={16} 
                    slidesPerView={1}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                    }}
                >
                    {items.map((it, idx) => (
                        <SwiperSlide key={idx}>
                        <div className="flex flex-col gap-[9px]">
                            <Bubble variant="q">{t(it.q)}</Bubble>
                            <Bubble variant="a">{t(it.a)}</Bubble>
                        </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="flex justify-between mt-[20px] xl:hiddem items-center gap-3">
                    <button
                    className="news-prev w-[46px] h-[22px] xl:w-[56px] xl:h-[22px] rounded-[6px] border border-[#061A77] text-[#061A77] flex items-center justify-center hover:bg-[#061A77] hover:text-white transition"
                    type="button"
                    aria-label="Previous"
                    >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path
                        d="M15 18l-6-6 6-6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        />
                    </svg>
                    </button>

                    <button
                    className="news-next w-[46px] h-[22px] xl:w-[56px] xl:h-[22px] rounded-[6px] bg-[#061A77] text-white flex items-center justify-center hover:opacity-90 transition"
                    type="button"
                    aria-label="Next"
                    >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path
                        d="M9 6l6 6-6 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        />
                    </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
  );
}

export default QA;
